import React, { Component } from "react"
// import Tabletop from "tabletop"
import Papa from "papaparse"
import { withRouter } from "react-router-dom"

import Rolls from "./Rolls"
import Combinations from "./Combinations"
import Sushi from "./Sushi"
import Sides from "./Sides"
import Others from "./Others"
import Beverages from "./Beverages"
import PartyTrays from "./PartyTrays"

import S from "./style"

class Menu extends Component {
    state = {
        tabs: ["Rolls", "Combinations", "Sushi", "Sides", "Others", "Beverages", "Party Trays"],
        currentTab: "Rolls",
        data: {},
        loading: true,
        lastPos: 0,
        xDown: null,
        yDown: null
    }
    componentDidMount() {
        // Tabletop.init(
        //     {
        //         key: `1FrbltyDxYZzZ2AH90UZN91dCfjqS-fbHCfbf0vldBkE`,
        //         callback: googleData => {
        //             const data = googleData
        //             this.setState({
        //                 data: googleData,
        //                 loading: false
        //             })
        //         },
        //     }
        // )
        Papa.parse('https://docs.google.com/spreadsheets/d/e/2PACX-1vQ8I1UoizL3zQQa2QbPcrGftcWrjrkwGNf8gfVKQOufyRToaMI5Z4NSghLWkWtz0gpEGTjGZnY_jd86/pub?output=csv', {
            download: true,
            header: true,
            complete: results => {
                const data = results.data
                this.splitData(data)
            },
            simpleSheet: true
        })
        window.addEventListener("scroll", this.throttle)
        window.addEventListener('touchstart', this.handleTouchStart, false)
        window.addEventListener('touchmove', this.handleTouchMove, false)
        setTimeout(this.removeSwipeMessage, 750)
    }
    componentDidUpdate() {
        this.addHover()
    }

    splitData = (data) => {
        let finalData = {}
        let currentTab = []
        data.forEach(item => {
            if(item.name === "SPLIT") {
                finalData[item.in] = currentTab
                currentTab = []
            } else {
                currentTab.push(item)
            }
        })
        this.setState({
            data: finalData,
            loading: false
        })
    }

    getTouches = (e) => {
        return e.touches
    }

    handleTouchStart = (e) => {
        const firstTouch = this.getTouches(e)[0]
        this.setState({
            xDown: firstTouch.clientX,
            yDown: firstTouch.clientY
        })
    }                                          
    
    handleTouchMove = (e) => {
        if(!this.state.xDown || !this.state.yDown) {
            return
        }
        const xUp = e.touches[0].clientX                           
        const xDiff = this.state.xDown - xUp    
        if (xDiff > 9) {
            this.nextTab("right")
        } else if (xDiff < -7){
            this.nextTab("left")
        }
        this.setState({
            xDown: null,
            yDown: null
        })
    }

    addHover = () => {
        const rolls = document.querySelectorAll(".roll")
        rolls.forEach(roll => {
            roll.addEventListener("mouseover", () => {
                roll.classList.add("show")
            })
            roll.addEventListener("mouseleave", () => {
                roll.classList.remove("show")
            })
        })
    }
    selectTab = (e) => {
        const active = document.querySelectorAll(".active")
        if(active.length > 0) {
            for(let i = 0; i < active.length; i++) {
                active[i].classList.remove("active")
            }
        }
        e.target.parentNode.parentNode.classList.add("active")
        this.setState({
            currentTab: e.target.getAttribute("name")
        })
        window.scrollTo(0, 0)
    }
    hideTabs = () => {
        const tabs = document.querySelector(".tabs")
        if(!tabs) { return }
        if(window.scrollY > this.state.lastPos) {
            tabs.style.top = "-70px"
        } else {
            tabs.style.top = "0"
        }
        this.setState({
            lastPos: window.scrollY
        })
    }
    throttle = () => {
        let time = Date.now()
        let fn = this.hideTabs()
        return function() {
            if((time + 75 - Date.now()) < 0) {
                fn()
                time = Date.now()
            }
        }     
    }
    nextTab = (dir) => {
        const curIndex = this.state.tabs.indexOf(this.state.currentTab)
        const curTab = dir === "left" ? (curIndex === 0 ? this.state.tabs[this.state.tabs.length-1] : this.state.tabs[curIndex-1]) : curIndex === this.state.tabs.length-1 ? this.state.tabs[0] : this.state.tabs[curIndex+1]
        this.setState({
            currentTab: curTab
        })
        window.scrollTo(0, 0)
    }
    handleArrow = (e) => {
        if(e.currentTarget.id === "-") {
            this.nextTab("left")
        } else {
            this.nextTab("right")
        }
    }
    removeSwipeMessage = () => {
        const message = document.querySelector("#message")
        message.style.opacity = "0"
    }
    componentWillUnmount() {
        window.removeEventListener("scroll", this.throttle)
    }
    render() {
        return(
            <S.Container1>
                <S.Overlay></S.Overlay>
                <S.Message id="message">SWIPE TO CHANGE TABS</S.Message>
                <S.DotDiv>
                    <S.Dot name="Rolls" className={this.state.currentTab === "Rolls" ? "black" : null} onClick={this.selectTab}></S.Dot>
                    <S.Dot name="Combinations" className={this.state.currentTab === "Combinations" ? "black" : null} onClick={this.selectTab}></S.Dot>
                    <S.Dot name="Sushi" className={this.state.currentTab === "Sushi" ? "black" : null} onClick={this.selectTab}></S.Dot>
                    <S.Dot name="Sides" className={this.state.currentTab === "Sides" ? "black" : null} onClick={this.selectTab}></S.Dot>
                    <S.Dot name="Others" className={this.state.currentTab === "Others" ? "black" : null} onClick={this.selectTab}></S.Dot>
                    <S.Dot name="Beverages" className={this.state.currentTab === "Beverages" ? "black" : null} onClick={this.selectTab}></S.Dot>
                    <S.Dot name="Party Trays" className={this.state.currentTab === "Party Trays" ? "black" : null} onClick={this.selectTab}></S.Dot>
                </S.DotDiv>
                <S.ArrowDiv id="-" onClick={this.handleArrow} left="-10px">
                    <S.LeftArrow className="fas fa-chevron-left"></S.LeftArrow>
                </S.ArrowDiv>
                <S.ArrowDiv id="+" onClick={this.handleArrow} right="-10px">
                    <S.RightArrow className="fas fa-chevron-right" ></S.RightArrow>
                </S.ArrowDiv>
                <S.TabContainer className="tabs">
                    <S.Sign className="active">
                        <S.Tab>
                            <S.Chain left></S.Chain>
                            <S.Chain></S.Chain>
                            <S.TabName name="Rolls" onClick={this.selectTab}>ROLLS</S.TabName>
                        </S.Tab>
                    </S.Sign>
                    <S.Sign>
                        <S.Tab>
                            <S.Chain left></S.Chain>
                            <S.Chain></S.Chain>
                            <S.TabName name="Combinations" onClick={this.selectTab}>COMBINATONS</S.TabName>
                        </S.Tab>
                    </S.Sign>
                    <S.Sign>
                        <S.Tab>
                            <S.Chain left></S.Chain>
                            <S.Chain></S.Chain>
                            <S.TabName name="Sushi" onClick={this.selectTab}>SUSHI</S.TabName>
                        </S.Tab>
                    </S.Sign>
                    <S.Sign>
                        <S.Tab>
                            <S.Chain left></S.Chain>
                            <S.Chain></S.Chain>
                            <S.TabName name="Sides" onClick={this.selectTab}>SIDES</S.TabName>
                        </S.Tab>
                    </S.Sign>
                    <S.Sign>
                        <S.Tab>
                            <S.Chain left></S.Chain>
                            <S.Chain></S.Chain>
                            <S.TabName name="Others" onClick={this.selectTab}>OTHERS</S.TabName>
                        </S.Tab>
                    </S.Sign>
                    <S.Sign>
                        <S.Tab>
                            <S.Chain left></S.Chain>
                            <S.Chain></S.Chain>
                            <S.TabName name="Beverages" onClick={this.selectTab}>BEVERAGES</S.TabName>
                        </S.Tab>
                    </S.Sign>
                    <S.Sign>
                        <S.Tab>
                            <S.Chain left></S.Chain>
                            <S.Chain></S.Chain>
                            <S.TabName name="Party Trays" onClick={this.selectTab}>PARTY TRAYS</S.TabName>
                        </S.Tab>
                    </S.Sign>
                </S.TabContainer>
                <S.TitleDiv className={this.state.loading ? "hide" : ""} color={this.state.currentTab === "Rolls" ? "false" : "true"}>
                    <S.Title tab={this.state.currentTab}>{this.state.currentTab.toUpperCase()}</S.Title>
                </S.TitleDiv>
                {
                    this.state.loading
                        ?
                            <S.Spinner className="fas fa-circle-notch fa-spin"></S.Spinner>
                        :
                    this.state.currentTab === "Rolls"
                        ?
                            <Rolls freshRolls={this.state.data.freshRolls} cookedRolls={this.state.data.cookedRolls}/>
                        :
                    this.state.currentTab === "Combinations"
                        ?
                            <Combinations entrees={this.state.data.entrees} bentos={this.state.data.bentos} sushiCombos={this.state.data.sushiCombo} sushiLunchSpecial={this.state.data.sushiLunchSpecial}></Combinations>
                        :
                    this.state.currentTab === "Sushi"
                        ?
                            <Sushi data={this.state.data} nigiri={this.state.data.nigiri} sashimi={this.state.data.sashimi} handRoll={this.state.data.handRoll} cutRoll={this.state.data.cutRoll}/>
                        :
                    this.state.currentTab === "Sides"
                        ?
                            <Sides data={this.state.data} sides={this.state.data.sides}/>
                        :
                    this.state.currentTab === "Others"
                        ?
                            <Others sides={this.state.data.sides} noodles={this.state.data.noodles} salads={this.state.data.salads} donburi={this.state.data.donburi} partyTrays={this.state.data.partyTrays} desserts={this.state.data.desserts}/>
                        :
                    this.state.currentTab === "Beverages"
                        ?
                            <Beverages beverages={this.state.data.beverages}/>
                        :
                            <PartyTrays partyTrays={this.state.data.partyTrays} />
                    }
            </S.Container1>
        )
    }
}

export default withRouter(Menu)